<template>
  <b-card class="shadow column grid-stack-item-content flex-container">
    <div slot="header">
      <window-header cmp-title="Log a support ticket" widget-name="support"></window-header>
    </div>
    <div class="flex-full-height p-2">
      <b-form>
        <label class="sr-only" for="inlineFormInputName2">Name</label>
        <b-input class="mb-1 input-xs" id="inlineFormInputName2" v-model="subject" placeholder="Enter issue title" />
        <label class="sr-only" for="inlineFormInputGroupUsername2">Describe your issue and how it occured</label>
        <b-input-group left="@" class="mb-1">
          <b-form-textarea :rows="2" v-model="description" class="textarea-xs" id="inlineFormInputGroupUsername2" placeholder="Describe your issue and how it occured" />
        </b-input-group>

        <b-form-select id="selectTracker" v-model="categoryId" :options="categories" class="mb-1 select-xs" />
        <b-form-select id="selectPriority" v-model="priorityId" :options="priorities" class="mb-1 select-xs" />
        <b-button-group class="float-right mt-1">
          <b-button @click="$store.getters['cmp/all']['support']['enabled'] = false" class="btn-xs" size="sm" variant="outline-secondary">Cancel</b-button>
          <b-button :disabled="!projectId || saving" @click="saveIssue" class="btn-xs" size="sm" variant="outline-success">Save</b-button>
        </b-button-group>
      </b-form>
    </div>
  </b-card>
</template>
<script>

import WindowHeader from '../common/WindowHeader'
export default {
  name: 'support-tool',
  components: {WindowHeader},
  data () {
    return {
      saving: false,
      trackerId: null,
      statusId: null,
      priorityId: null,
      categoryId: null,
      subject: null,
      description: null,
      priorities: [],
      categories: [],
      statuses: [],
      assigneeId: null,
    }
  },
  computed: {
    projectId () {
      return this.$store.getters['user/settings'].filter(s => s.usedfor === 'support' && s.param === 'project')
        .map(s => s.value)[0]
    }
  },
  mounted() {
    if (!this.projectId) {
      this.$notify({
        title: 'ERROR',
        text: 'No project selected',
        type: 'error'
      })
      return
    }
    this.loadSupportConfig()
    this.loadIssueStatuses()
    this.loadIssuePriorities()
    this.loadProjectCategories()
  },
  methods: {
    saveIssue () {
      let payload = {
        subject: this.subject,
        description: this.description,
        tracker_id: this.trackerId,
        status_id: this.statusId,
        priority_id: this.priorityId,
        assigned_to_id: this.assigneeId,
        project_id: parseInt(this.projectId),
        category_id: this.categoryId
      }

      this.saving = true
      this.$http.post('/api/redmine/issues.json', {
        issue:payload
      }).then(res => {
        this.$notify({
          title: 'Done!',
          text: 'Support issue added',
          type: 'success'
        })
        this.$store.getters['cmp/all']['support']['enabled'] = false
        this.saving = false
      }, res => {
        this.$notify({
          title: 'ERROR',
          text: 'Could not save issue',
          type: 'error'
        })
        this.saving = false
      })
    },
    loadSupportConfig () {
      let me = this
      this.$http.get('/api/layers/redmine-support-config')
        .then(res => {
          if (res && res.body) {
            me.trackerId = parseInt(res.body['tracker_id']) || null
            me.assigneeId = parseInt(res.body['user']) || null
          }
        }, r => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not get redmine support config',
            type: 'error'
          })
        })
    },
    loadProjectCategories () {
      this.$http.get(`/api/redmine/projects/${this.projectId}/issue_categories.json`)
        .then(res => {
          res = res.body.issue_categories
          let data= res.map(m => {
            return {
              text: m.name,
              value: m.id
            }
          })

          data.unshift({
            text: "Select category",
            value: null
          })

          this.categories = data
          // this.categoryId = data[1].value

        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not load project categories',
            type: 'error'
          })
        })
    },
    loadIssuePriorities() {
      this.$http.get(`/api/redmine/enumerations/issue_priorities.json`)
        .then(res => {
          res = res.body.issue_priorities
           let data = res.map(m => {
            return {
              text: m.name,
              value: m.id
            }
          })

          data.unshift({
            text: "Select priority",
            value: null
          })

          this.priorities = data
          // this.priorityId = data[1].value

        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not load project priorities',
            type: 'error'
          })
        })
    },
    loadIssueStatuses() {
      let me = this
      this.$http.get(`/api/redmine/issue_statuses.json`)
        .then(res => {
          res = res.body.issue_statuses
          me.statusId = res.filter(s => s.name === "Backlog")[0]['id']
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not load issue statuses',
            type: 'error'
          })
        })
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/map/SupportTool.vue